// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8e825e60","83":"8f5c7025","294":"575d0fd0","587":"f1d3b9e4","601":"d3e3a5fc","695":"3f7cfb53","704":"5cd94d8f","787":"3b1711bf","825":"91fe37da","901":"455f4ac2","993":"38556ab6"}[chunkId] + ".chunk.js";
};